import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchTaskAlarms } from '@api/u8.api.task';
import { saveAlarmItem, deleteAlarmItem } from '@api/u8.api.alarm.item';
import AlarmUserSelect from '../../../components/alarm.user.select';
export default {
  props: {
    taskID: {
      default: 0
    },
    taskUniID: {
      default: ''
    }
  },
  data: function data() {
    return {
      data: [],
      loading: false,
      dialogFormVisible: false,
      notifyMethods: [],
      notifyUsers: [],
      form: {
        id: 0,
        taskID: '',
        taskForeignID: '',
        monitorType: '',
        notifyMethod: '',
        notifyUsers: ''
      },
      dialogWidth: '50%',
      formLabelWidth: '150px',
      dialogTitle: '添加告警配置',
      isFromEdit: false
    };
  },
  components: {
    AlarmUserSelect: AlarmUserSelect
  },
  mounted: function mounted() {
    this.dialogWidth = this.$ajustDialogWidth();
    this.fetchData(true);
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loading = true;
      searchTaskAlarms({
        'taskID': this.taskID
      }).then(function (res) {
        _this.data = res.records;
        _this.loading = false;
      }).catch(function (err) {
        console.log('err', err);
        _this.loading = false;
      });
    },
    addAlarm: function addAlarm() {
      //添加一条新记录
      this.isFromEdit = false;
      this.dialogTitle = "添加告警配置";

      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
        this.$refs['form'].clearValidate();
      }

      Object.assign(this.form, this.$options.data().form);
      this.notifyMethods = [];
      this.notifyUsers = [];
      this.dialogFormVisible = true;
    },
    editRow: function editRow(index, row) {
      //编辑当前记录
      this.isFromEdit = true;
      this.dialogTitle = "编辑告警配置";

      if (this.$refs['form']) {
        this.$refs['form'].clearValidate();
      }

      if (row.notifyMethod && row.notifyMethod.length > 0) {
        this.notifyMethods = row.notifyMethod.split(',');
      } else {
        this.notifyMethods = [];
      }

      if (row.notifyUsers && row.notifyUsers.length > 0) {
        this.notifyUsers = row.notifyUsers.split(',');
      } else {
        this.notifyUsers = [];
      }

      this.form = Object.assign({}, row);
      this.form.createTime = null;
      this.dialogFormVisible = true;
    },
    deleteRow: function deleteRow(index, row) {
      var _this2 = this;

      //删除当前记录
      this.$confirm('确定要删除该配置吗', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteAlarmItem({
          "id": row.id
        }).then(function (res) {
          _this2.$message({
            type: 'success',
            message: '删除成功'
          });

          _this2.fetchData();
        }).catch(function (err) {
          console.log('err', err);
        });
      }).catch(function () {
        _this2.$message({
          type: 'warning',
          message: '取消删除'
        });
      });
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;

      //添加或者编辑表单提交
      this.form.taskForeignID = this.taskID;
      this.form.taskID = this.taskUniID;

      if (this.notifyMethods && this.notifyMethods.length > 0) {
        this.form.notifyMethod = this.notifyMethods.join(',');
      } else {
        this.form.notifyMethod = '';
      }

      if (this.notifyUsers && this.notifyUsers.length > 0) {
        this.form.notifyUsers = this.notifyUsers.join(',');
      } else {
        this.form.notifyUsers = '';
      }

      saveAlarmItem(_objectSpread({}, this.form)).then(function (res) {
        _this3.dialogFormVisible = false;

        _this3.$message({
          message: '操作成功',
          type: 'success'
        });

        _this3.fetchData();
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    resetForm: function resetForm(formName) {
      //添加或者编辑表单，清理表单数据
      this.dialogFormVisible = false;

      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
        this.$refs[formName].clearValidate();
      } else {
        console.log("the form is not exists." + formName);
      }
    }
  }
};